export const initialState = {
  currentConsent: null,
  consentOptionSelected: null,
  showModalPrivacy: false,
  currentWidgetHtmlId: null,
  hideMessage: false,
};
